import QuestionsSection from './QuestionsSection'

export default QuestionsSection;